import {
  Component,
  ElementRef,
  OnInit,
  QueryList,
  ViewChildren,
  ViewEncapsulation
} from '@angular/core';
import { AddUserTabs } from '../../../enums/tabs';

@Component({
  selector: 'prism-user-add',
  templateUrl: './user-add.component.html',
  styleUrl: './user-add.component.scss',
  encapsulation: ViewEncapsulation.None 
})
export class UserAddComponent implements OnInit {
  tabs = [AddUserTabs.AddUser, AddUserTabs.BulkAddUser];
  selectedIndex = 0;

  @ViewChildren('tabHeader') tabHeaders!: QueryList<ElementRef<HTMLElement>>;

  ngOnInit(): void { }

  onHeaderKey(event: KeyboardEvent, index: number): void {
    const key = event.key;
    const totalTabs = this.tabs.length;

    if (key === 'ArrowRight' || key === 'ArrowDown') {
      const nextIndex = (index + 1) % totalTabs;
      this.selectedIndex = nextIndex;
      setTimeout(() => {
        this.tabHeaders.get(nextIndex)?.nativeElement.focus();
      });
      event.preventDefault();
    } else if (key === 'ArrowLeft' || key === 'ArrowUp') {
      const prevIndex = (index - 1 + totalTabs) % totalTabs;
      this.selectedIndex = prevIndex;
      setTimeout(() => {
        this.tabHeaders.get(prevIndex)?.nativeElement.focus();
      });
      event.preventDefault();
    } else if (key === 'Enter' || key === ' ') {
      this.setSelected(index);
      event.preventDefault();
    }
  }

  setSelected(index: number): void {
    this.selectedIndex = index;
  }
}
